<template>
  <div class="footer-additional-links">
    <FooterLink
      v-for="(link, index) in bottomLinks"
      :key="'bottom-link' + index"
      class="footer-additional-links__link"
      :href="`https://${link.baseUrl}/${locale}${link.path}`"
      :text="$t(`${link.key}`)"
      @click="$emit('navigation', link)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bottomLinks from './footer-bottom-links'
import FooterLink from '@/components/Footer/FooterLink.vue'

export default {
  name: 'FooterAdditionalLinks',
  components: { FooterLink },
  props: { isDesktop: Boolean },

  data() {
    return {
      bottomLinks,
    }
  },

  computed: {
    ...mapGetters({
      locale: 'page/locale',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import './footer-settings';

.footer-additional-links {
  display: inline-block;
  order: 3;
  padding-top: 20px;
  font-size: $f-size-xsmall;
  line-height: 1.5;

  @media (min-width: $mobile-bp) {
    position: relative;
    top: 2px;
    order: 2;
    padding-top: 0;
  }

  &__link {
    display: block;
    padding: 17px 10px 0 0;
    color: $c-grey-mid-3;

    @media (min-width: $mobile-bp) {
      display: inline-block;
      padding: 0 30px 0 0;
    }

    &:hover {
      color: $c-white;
    }
  }
}
</style>

<i18n src="@/locales/footer_additional_links.json">
</i18n>
